module.exports = __webpack_public_path__ + "static/media/videoThumbNailSample.d0a95e36.png";